import UserAvatarApi from '@/api/user/user-avatar-api';

export default {
  data() {
    return {
      userAvatarApi: new UserAvatarApi(this.appData.currentUser),
      avatarObjectUrl: null,
      isAvatarError: false
    };
  },

  computed: {
    avatarUrl() {
      return this.avatarObjectUrl;
    },

    showAvatarImage() {
      return !!this.avatarObjectUrl && !this.isAvatarError;
    }
  },

  beforeDestroy() {
    this.revokeAvatarUrl();
  },

  methods: {
    async loadAvatar(userId) {
      this.revokeAvatarUrl();
      this.isAvatarError = false;

      if (!userId) return;

      try {
        const response = await this.userAvatarApi.getAvatarBlob(userId);

        if (response?.data instanceof Blob) this.avatarObjectUrl = URL.createObjectURL(response.data);
      } catch {
        this.isAvatarError = true;
      }
    },

    revokeAvatarUrl() {
      if (this.avatarObjectUrl) URL.revokeObjectURL(this.avatarObjectUrl);

      this.avatarObjectUrl = null;
    },

    onAvatarError() {
      this.isAvatarError = true;
    }
  }
};
